import { createContext } from 'react';

const defaultThemeData = {
    id: 'default',
    colors: {
        primary: '#0B2545',
        secondary: '#13315C',
        accent: '#13C1BB',
        background: '#F5F7FA',
        text: '#0F172A',
    },
};

const ThemeContext = createContext({
    themeData: defaultThemeData,
    logo: null,
    businessName: null,
    loadingTheme: false,
    errorTheme: null,
    subdomain: null,
    refreshTheme: async () => defaultThemeData,
});

export const ThemeProvider = ({ children }) => children;

export default ThemeContext;
